<template>
<div :class="thClass" @click="sort">
    <div class="cfd-th-inner">
        <div v-if="isSortable" class="cfd-sort">
            <svg class="cfd-sorter" fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z" fill="#010101"/>
            </svg>
        </div>
        <div v-if="column.Help" class="cfd-help" :data-tipok-title="column.Help">
            <svg class="cfd-helper" fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0h24v24H0z" fill="none"/>
                <path d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"/>
            </svg>
        </div>
        <div class="cfd-text">{{ column.Header }}</div>
    </div>
</div>
</template>

<script>
export default {
    name: 'InstrumentTableHeaderItem',

    props: {
        column: {
            type: Object,
            required: true
        }
    },

    computed: {
        thClass () {
            return {
                'cfd-th': true,
                'is-sorted': this.isSorted,
                'is-descending': this.isDescending,
                'is-right-aligned': this.isRightAligned
            };
        },

        isSortable () {
            return this.column.IsSorted;
        },

        isSorted () {
            return this.$store.state.sortKey === this.column.MatchingFieldName;
        },

        isDescending () {
            return this.isSorted && !this.$store.state.sortIsAscending;
        },

        isRightAligned () {
            return this.column.TextAlignment === 'right';
        }
    },

    methods: {
        sort (ev) {
            if (!this.isSortable) {
                return;
            }
            if (ev.target.closest && ev.target.closest('.cfd-help')) {
                return;
            }
            if (this.column.MatchingFieldName === this.$store.state.sortKey) {
                this.$store.commit('setSortIsAscending', { sortIsAscending: !this.$store.state.sortIsAscending });
                return;
            }
            this.$store.commit('setSortKey', { sortKey: this.column.MatchingFieldName });
        }
    }
}
</script>

<style scoped>
.cfd-th {
    position: relative;
    z-index: 1;
    display: table-cell;
    vertical-align: top;
    box-shadow: inset 0 -1px 0 0 #e0e0e0;
    padding: 18px 32px;
}

.cfd-th:first-child {
    position: sticky;
    z-index: 2;
    left: 0;
    background-color: #fff;
    box-shadow: inset 0 -1px 0 0 #e0e0e0, inset -1px 0 0 0 #e0e0e0;
}

.cfd-th.is-right-aligned .cfd-th-inner {
    justify-content: flex-end;
}

.cfd-sort {
    margin-left: -28px;
    padding: 2px 6px;
    width: 16px;
    height: 16px;
    opacity: 0;
    transition: opacity .25s ease-in, transform .25s ease-in-out;
    float: left;
}

.cfd-th:hover .cfd-sort {
    opacity: .54;
    transition-timing-function: ease-out, ease-in-out;
}

.cfd-th.is-sorted .cfd-sort,
.cfd-th.is-sorted:hover .cfd-sort {
    opacity: .87;
    transition-timing-function: ease-out, ease-in-out;
}

.cfd-th.is-descending .cfd-sort {
    transform: rotateZ(180deg);
    transition-timing-function: ease-out, ease-in-out;
}

.cfd-sorter {
    flex-shrink: 0;
    max-width: 100%;
    height: auto;
}

.cfd-text {
    font-size: 12px;
    line-height: 20px;
    color: rgba(0, 0, 0, .54);
}

.cfd-sort ~ .cfd-text {
    cursor: default;
}

.th.is-sorted .cfd-text,
.th:hover .cfd-text {
    color: rgba(0, 0, 0, .87);
}

.cfd-help {
    position: relative;
    z-index: 1;
    margin: -6px -32px -6px 0;
    padding: 6px;
    width: 20px;
    height: 20px;
    opacity: .54;
    transition: opacity .125s ease-in;
    float: right;
}

.cfd-help:hover {
    opacity: .87;
    transition-timing-function: ease-out;
}

.cfd-helper {
    max-width: 100%;
    height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/desktop/InstrumentTableHeaderItem.vue